<template>
  <md-button class="md-icon-button" @click="action()">
    <md-icon class="text-gray">star_outline</md-icon>
  </md-button>
</template>
<script>
import StatusUpdateMixin from "@/mixins/StatusUpdateMixin";

export default {
  name: "ActionTrash",
  props: ["item", "collection"],
  mixins: [StatusUpdateMixin],
  data: () => ({
    status: "S"
  })
};
</script>